<div>
  <div class="mailing_block_title">{{ title }}</div>
  <div
    class="custom-control custom-radio custom-control-inline"
    *ngFor="let variant of variants">
    <input
      [name]="name"
      type="radio"
      [id]="variant.id"
      [value]="variant.value"
      [formControl]="control"
      class="custom-control-input cursor_pointer" />
    <label
      class="custom-control-label cursor_pointer pt-1"
      [for]="variant.id"
      >{{ variant.title }}</label
    >
  </div>
  <div *ngIf="error" class="input_error_text">{{ error }}</div>
</div>
